'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationGridDirective = function OnlineLogitCalibrationGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/online-logit-calibration-grid.html'),
    controller: 'OnlineLogitCalibrationGridController',
    scope: {
      maxRtp: '=',
      logitData: '=',
      selectedCalibrationData: '=',
      screenState: '='
    },
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
      scope.prepareDataForGrid();
      scope.computeScenarioName();
      scope.$on('gridExpand:online-logit-calibration-review', scope.toggleExpandCollapseGrid);
      scope.$on('grid:retrievedRowsByKeyColumns:' + scope.gridId, scope.updateGridColumns);
      scope.$on('online-logit-calibration:sync-grid', scope.syncGridWithChartUpdates);
      scope.$on('online-logit-calibration:get-updates', scope.getUpdates);
      scope.$on('online-logit-calibration:reload-chart-and-grid:', scope.prepareDataForGrid);
    }
  };
};
OnlineLogitCalibrationGridDirective.$inject = [];
module.exports = OnlineLogitCalibrationGridDirective;